const defaultSourceAndDeviceType = 'WEB_HOME';

export function isSessionStorageEnabled() {
  return window.hasStorage;
}

export function saveSourceAndDeviceTypeOnSessionStorage(sessionStorageItemName, value) {
  if (isSessionStorageEnabled()) {
    window.sessionStorage.setItem(sessionStorageItemName, value);
  }
}

export function getSourceAndDeviceTypeOnSessionStorage(sessionStorageItemName, defaultValue) {
  return isSessionStorageEnabled()
    ? window.sessionStorage.getItem(sessionStorageItemName)
    : defaultValue;
}

export function getDeviceByWidth(width, MAX_MOBILE_WIDTH) {
  return width <= MAX_MOBILE_WIDTH ? 'mobile' : 'web';
}

export function getValidSourceAndDeviceType(sources, device, suffixSource, defaultValue) {
  return sources[`${device}_${suffixSource}`] || defaultValue;
}

function getSourceAndDeviceType(sources, device, route) {
  if (sources && Object.keys(sources).length && device && route) {
    const sanitizedRoute = route.toLowerCase();
    let suffixSource = 'HOME';
    if (sanitizedRoute.includes('/cat') || sanitizedRoute.includes('/pro')) {
      suffixSource = 'PRODUCTPAGE';
    } else if (sanitizedRoute.includes('/checkout')) {
      suffixSource = 'CHECKOUT';
    } else if (sanitizedRoute.includes('/bag')) {
      suffixSource = 'BAG';
    } else if (sanitizedRoute.includes('/my-account')) {
      suffixSource = 'ACCOUNT';
    }

    const sanitizeDevice = !device || device === 'desktop' ? 'WEB' : device.toUpperCase();
    if (['WEB', 'MOBILE'].includes(sanitizeDevice)) {
      return getValidSourceAndDeviceType(
        sources,
        sanitizeDevice,
        suffixSource,
        defaultSourceAndDeviceType,
      );
    }
  }

  return defaultSourceAndDeviceType;
}

export default getSourceAndDeviceType;
